import { Select as BaseSelect } from 'antd';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 20px 0 25px;
  display: flex;
  align-items: center;
  z-index: 10;
  background-color: #fff;

  nav li {
    display: flex;
    align-items: center;
  }
`;

export const Select = styled(BaseSelect)`
  width: 130px;

  .ant-select-selector {
    padding-left: 0 !important;
    font-size: 20px;
    color: #0046ff;
  }

  .ant-select-arrow {
    color: #0046ff;
    font-size: 16px;
  }
`;

export const Divider = styled.div`
  height: 20px;
  width: 1px;
  background-color: #1e1e1e;
  opacity: 0.3;
  margin-right: 10px;
`;

const clickableStyle = css`
  cursor: pointer;
  color: #0046ff;
  padding: 0 4px;

  &:hover {
    color: rgb(0 0 0 / 88%);
    background-color: rgb(0 0 0 / 6%);
  }
`;
export const Title = styled.div<{ clickable?: boolean }>`
  color: #4a4a4a;
  font-size: 20px;
  ${(props) => (props.clickable ? clickableStyle : '')}
`;
